// frontend/src/components/shared/ScrollRestoration.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A component that listens for route changes and scrolls the main content
 * area to the top. This is necessary for SPAs with custom scroll containers.
 */
export function ScrollRestoration() {
  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: The effect should re-run on pathname change.
  useEffect(() => {
    const mainContent = document.getElementById('main-content-area');
    if (mainContent) {
      mainContent.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}
